import { useState, useEffect, useCallback } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User } from "lucide-react";
import { routes } from "@/src/utilities";
import { useAppSelector } from "@/src/store/hooks";
import { logout } from "@/src/store/reducers/users/userSlice";
import { useDispatch } from "react-redux";

export function AuthButton() {
  const router = useRouter();
  const dispatch = useDispatch();
  const { token, username } = useAppSelector((state) => state.userStateReducer);

  const handleSignout = useCallback(() => {
    dispatch(logout());
    router.push("/"); // redirect to login
  }, [dispatch]);

  if (!token) {
    // show login button if not authenticated
    return (
      <Button
        variant="ghost"
        size="sm"
        className="text-white font-semibold hover:bg-white/10 hover:text-primary"
        onClick={() => window.open(`/${routes.LOGIN}`, '_blank')}
      >
        Login
      </Button>
    );
  }

  // show dropdown menu if authenticated
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="text-white hover:bg-white/10 cursor-pointer"
        >
          <User className="w-5 h-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{username}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleSignout}>Sign Out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
